import { render } from "./InstanceInput.vue?vue&type=template&id=27ac4fb1"
import script from "./InstanceInput.vue?vue&type=script&lang=js"
export * from "./InstanceInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__